<template>
  <CountryPage country="schengen" />
</template>